export const PAYMENT_OASIS_MISSING_MESSAGE =
  'No eligible payment OASIS is available for this billing period.';
